import { useEffect, useState } from "react";

export const useLocalStorageExpire = (key, defaultValue, minutes) => {
  const getStoredValue = () => {
    if (typeof window === "undefined") return defaultValue;

    const itemStr = localStorage.getItem(key);
    if (!itemStr) return defaultValue;

    try {
      const item = JSON.parse(itemStr);
      const now = Date.now();

      // Si no tiene expiry o ya expiró → borrar y usar default
      if (!item.expiry || now > item.expiry) {
        localStorage.removeItem(key);
        return defaultValue;
      }

      return item.value;
    } catch (e) {
      // Si algo raro hay en el JSON, reseteamos
      localStorage.removeItem(key);
      return defaultValue;
    }
  };

  const [value, setValue] = useState(getStoredValue);

  useEffect(() => {
    if (typeof window === "undefined") return;

    const now = Date.now();
    const itemStr = localStorage.getItem(key);
    let existing = null;

    if (itemStr) {
      try {
        existing = JSON.parse(itemStr);
      } catch (e) {
        existing = null;
      }
    }

    // 🔴 Si ya existe, no está expirado y el value es el mismo → NO renuevo expiry
    if (
      existing &&
      existing.expiry &&
      now < existing.expiry &&
      existing.value === value
    ) {
      return;
    }

    // 🟢 Si no existe, expiró o cambió el value → escribo nuevo expiry
    const item = {
      value,
      expiry: now + minutes * 60 * 1000,
    };

    localStorage.setItem(key, JSON.stringify(item));
  }, [key, value, minutes]);

  return [value, setValue];
};


